import { initialize } from "launchdarkly-js-client-sdk";
import { baseRequestURL } from "api/BaseAPI";
const DEFAULT_FLAGS = !!LAUNCH_DARKLY_SKD_KEY
    ? {}
    : {
        // Default Flags
        "optimize-by": true,
        fairness: true,
        "ppt-exporter": true,
        "dataset-upload": false,
        "external-models": true,
        "user-compliance": true,
        "monitor-first": true,
        forecasting: true,
        "dashboard-infographic": true,
        "next-easy": true,
        "cors-force-credentials": true,
        "aible-dashboard": true,
        "data-readiness-warning": true,
        "dataset-whats-changed": true,
        "schema-monitor-update-credentials": true,
        "multicategorical-outcome": true,
        // ignore column values for nlq queries
        "nlq-column-exclusion": true,
        // AIBLE Optimize
        "sense-transformations": true,
        "light-gbm-shap-explore": true,
        "export-blueprints": true,
        balancer: true,
        "aible-sense": false,
        "aible-optimize": true,
        // Chataible
        "chat-aible": true,
        "chat-aible-buy-button": ENABLE_STRIPE,
        "chat-aible-hide-test-models": true,
        "chat-aible-document-summarization": true,
        "chat-aible-sql-queries": true,
        "chat-aible-whats-changed": true,
        "chat-aible-advanced-controls": true,
        "chat-aible-hide-conversations-from-chat": true,
        "completion-cache": true,
        "chat-aible-document-search": true,
        "nlq-dashboard": true,
        // download notebook on error
        "chat-aible-notebook-download": true,
        // Show the option to ignore NLQ data if the query is too large
        "allow-ignore-nlq-data": true,
        "add-collaborators-button": true,
        "chat-save-dropdown-options": true,
        // Verizon
        "chat-aible-hide-open-ai-models": true,
        "chat-aible-hide-aws-models": true,
        "chat-aible-show-meta-models": false,
        // Hiding Gemini for edge deployment
        // "chat-aible-show-gemini": true,
        "auto-apply-chats": true,
        "model-fine-tuning": true,
        "custom-model-upload": true,
        "corpus-model-select": true,
        "document-set-kpi-analysis": true,
        // "kpi-analysis-onex": true,
        "next-autosave": false,
        //flag to hide token cost settings/token cost details on messages and from see what was sent
        // Remove for edge deployment so caching can be disabled
        // "chat-aible-hide-token-costs": true,
        //flag for new fine-tuning flow
        "create-training-data-from-use-case": true,
        // CVS
        focused_whats_changed: true,
        // Admin:
        "aible-settings": true,
        "allow-cloud-account-deletion": true,
        "add-workspace": false,
        admin: true,
        "user-activity-analytics": true,
        // Adding users: can be troublesome.
        // Academically, they're supposed to use the SAML SSO b/c we don't do email invites on GCP...
        // however, this would also make it not possible to "invite" existing users, SSO or not.
        "add-user": true,
        "llm-provisioning-settings": false,
        "user-management-settings": true,
        // New default features for CVS
        "agent-autonomy-controls": false,
        "agent-autonomy-recommended-setting": true,
        "aible-agent": true,
        // Currently hiding until users have Interns
        // "chat-agent-iq": true,
        // Updating flags for edge deployment
        "chat-reason": true,
        "chat-aible-templates": true,
        "show-advanced-agent-settings": true,
        // "chat-agent-iq": true, // Turning this off for customers for now for testing AibleSafeClaw
        // Do not filter for edge deployment when we are only positioning intern models
        // "provisioned-models-filter-interns": true,
        "new-chat-top-sample-templates": true,
        "agent-iq-save-workflow": true,
        "folder-creation-default-roles": true,
        // Show usecases tab again for edge deployments
        // "hide-chat-blueprints": true,
        "show-all-chat-templates": true,
        "show-media-templates": true,
        "enable-agents-templates-view": true,
        // Turning flag off for Edge, shows: Edge / Private Cloud when false, ProLiant (Edge) / HP PCAI (Private Cloud) when true.
        // "use-hpe-deploy-options": true,
        // Temporary fix for getting provisioned models to be 8000 max default, this will affect interns as well
        // Useful only while CVS does not have interns
        // "increased-provisioned-model-max-tokens": true,
        // Turning off for now as it is incomplete
        "chataible-focus-variable": false,
        // Give airgapped users ability to provision model from modal in Models & AI Feedback tab but still flagged off create connection/delete buttons
        "add-llm-through-api": true,
        // Model string input for airgapped single server k8s deployments to be able to create default gemini connection -> provision as necessary
        "chat-model-string-input": true,
        // Disabling Gemini for CVS, so adding flag to still include the gemini embeddings model
        // "include-gemini-embeddings-model": true,
        // Disabling prediction option for Nvidia demo // edge deployment
        "hide-prediction-nvidia-demo": true,
        // Showing hugging face for edge deployment
        "show-hugging-face-embeddings-model": true,
        "chat-guardrails": true,
        "spark-agents-templates-view": true,
        // This is now required for benchmark templates to work now that benchmark templates use this usecase
        "chat-aible-benchmark": true,
        "sql-transforms": false,
        // Flag that allows user to change their password in user management
        "update-current-user-password": true,
        // Allow database linking in agent setup dataset selection
        "template-setup-database-link": true,
        // Turn on chat streaming for spark boxes
        "chat-streaming-responses": true,
        // Enable AibleSafeClaw usecase/tile
        // "chat-aible-agent-c": true, // Turning off for regular spark customers for now
        "chat-aible-agent-reasoning-flow-step": true, // Allow the CREATE_CLAW reasoning step and creation within steps flow
        // Enables conversation memory settings
        "chat-conversation-memory": true,
        // "aible-claw-api-invocations": true // Turning on API Invocations in AibleSafeClaw for all spark users
        "agent-simple-analytics": true // Turn on simple analytics mode for sparks
    };
const user = {
    anonymous: true
};
const defaultLDOptions = {
    streaming: false,
    bootstrap: "localStorage"
};
const defaultLDTunneledOptions = Object.assign({
    eventsUrl: baseRequestURL + "v1/launchdarkly/events",
    baseUrl: baseRequestURL + "v1/launchdarkly/app",
    streamUrl: baseRequestURL + "v1/launchdarkly/clientstream"
}, defaultLDOptions);
let client = undefined;
export function isLaunchDarklyEnabled() {
    return Boolean(LAUNCH_DARKLY_SKD_KEY) && LAUNCH_DARKLY_SKD_KEY !== "null" && LAUNCH_DARKLY_SKD_KEY !== "undefined";
}
export function isLookerEnabled() {
    // Are we inside a looker Loader context?
    return window?.location?.pathname.indexOf("/project-resource/public/extension.loader") !== -1;
}
export const isSentryEnabled = () => {
    return Boolean(ENABLE_SENTRY);
};
export const initSentry = (id = undefined) => {
    const tagId = id === undefined ? "raven-js" : id;
    if (!isSentryEnabled())
        return new Promise((resolve, reject) => {
            return resolve(false);
        });
    const viaBugSplat = Boolean(SENTRY_VIA_BUGSPLAT);
    const configureSentryOnLoaded = () => {
        if (!window.Raven) {
            console.error("Raven sdk failed to parse/load, disabling.");
            return;
        }
        const hasSentryDSN = Boolean(SENTRY_DSN) && SENTRY_DSN !== "undefined" && SENTRY_DSN !== "null";
        if (!hasSentryDSN) {
            console.debug("Sentry not configured.");
            return;
        }
        Raven.config(SENTRY_DSN, {
            release: SENTRY_RELEASE,
            environment: SENTRY_ENVIRONMENT
        }).install();
        console.log("Configured Raven");
        if (viaBugSplat) {
            console.log("Setting up Raven bugsplat");
            Raven.setTransport((options) => {
                const headers = new Headers();
                headers.append("Sentry-Version", options.auth.sentry_version);
                headers.append("Sentry-Client", options.auth.sentry_client);
                headers.append("Sentry-Key", options.auth.sentry_key);
                headers.append("Sentry-Destination-Url", options.url);
                headers.append("Content-Type", "application/json");
                fetch(baseRequestURL + "v1/bugsplat", {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(options.data)
                }).then(function (response) {
                    if (response.ok) {
                        console.debug("Sentry report accepted!");
                        options.onSuccess();
                    }
                    else {
                        console.error("Sentry report rejected!");
                        options.onError();
                    }
                });
            });
        }
    };
    return new Promise((resolve, reject) => {
        if (window?.Raven !== undefined) {
            try {
                configureSentryOnLoaded();
            }
            catch (e) {
                console.error("Error in configureSentryOnLoaded!");
                return reject(e);
            }
            return resolve(true);
        }
        let script = document.querySelector(`#${tagId}`);
        if (script !== null && script.addEventListener !== undefined) {
            console.debug(`Adding load/error listeners to ${script}`);
            script.addEventListener("error", (event) => {
                console.error("Unable to load sentry js due to", event, "!");
                resolve(false);
            });
            script.addEventListener("load", (event) => {
                try {
                    configureSentryOnLoaded();
                }
                catch (e) {
                    console.error(`Error in configureSentryOnLoaded (${event} -> ${e})!`);
                    return reject(e);
                }
                return resolve(window?.Raven !== undefined);
            });
            return;
        }
        console.error(`Unable to find #${tagId} or window.Raven. disabling.`);
        resolve(false);
    });
};
const createLaunchDarklyClient = !!LAUNCH_DARKLY_SKD_KEY
    ? (failureCallback) => {
        const enableLaunchDarklyTunnel = Boolean(ENABLE_LAUNCHDARKLY_TUNNEL);
        const clientOptions = enableLaunchDarklyTunnel ? defaultLDTunneledOptions : defaultLDOptions;
        return new Promise((resolve, reject) => {
            let new_client;
            try {
                new_client = initialize(LAUNCH_DARKLY_SKD_KEY, user, clientOptions);
            }
            catch (e) {
                console.error("[LaunchDarkly] Unable to initialize.");
                reject(e);
                return;
            }
            new_client.on("ready", () => {
                console.debug("[LaunchDarkly] client is ready.");
                resolve(new_client);
            });
            if (failureCallback !== undefined) {
                new_client.on("failed", failureCallback);
                new_client.on("error", failureCallback);
            }
        });
    }
    : (failureCallback) => {
        return new Promise((resolve, reject) => {
            return resolve();
        });
    };
export const init = (failureCallback) => {
    return Promise.allSettled([initSentry(), createLaunchDarklyClient(failureCallback)]).then((results) => {
        let [sentry_loaded, launchdarkly_client] = results.map((item) => {
            if (item.status === "fulfilled")
                return item.value;
            if (item.status === "rejected")
                return item.reason;
        });
        console.debug("sentry_loaded", sentry_loaded, "launchdarkly_loaded", launchdarkly_client);
        if (launchdarkly_client !== undefined && !(launchdarkly_client instanceof Error)) {
            // set the module level global:
            console.debug("[LaunchDarkly] Setting module-level client");
            client = launchdarkly_client;
        }
        if (sentry_loaded instanceof Error) {
            console.error(`[Sentry] encountered ${sentry_loaded} on initSentry.`);
        }
        else {
            console.debug(`[Sentry] isEnabled: ${sentry_loaded}`);
        }
        return [sentry_loaded, launchdarkly_client];
    });
};
export const setUserContext = !!LAUNCH_DARKLY_SKD_KEY
    ? (username, onDone = undefined) => {
        const user = username ? { key: String(username).toLowerCase() } : { anonymous: true };
        client?.identify(user, undefined, onDone);
    }
    : (username, onDone = undefined) => {
        if (onDone !== undefined) {
            return onDone();
        }
        return;
    };
const ADMIN_FLAGS = {
    "spark-agents-templates-view": false,
    "chat-aible-kpi-switching-flow": true,
    "az-testing": true,
    "better-few-shot": true,
    "add-user": true,
    "agent-autonomy-controls": false,
    // "chat-agent-iq": true,
    "update-current-user-password": true,
    "admin-force-update-password": true,
    // "chat-aible-agent-c": true, // Turning off for regular spark customers for now
    "chat-aible-agent-reasoning-flow-step": true, // Turns on create claw from agent
    "chat-conversation-memory": true,
    "aible-claw-read-memory": true,
    // "aible-claw-api-invocations": true // Turning on API Invocations in AibleSafeClaw for all spark users
    "agent-simple-analytics": true // Turn on simple analytics mode for sparks
};
const SAFE_CLAW_FLAGS = {
    // This is a 'power user' that cannot change other users' passwords but has SafeClaw/AgentIQ
    "spark-agents-templates-view": false,
    "chat-aible-kpi-switching-flow": true,
    "az-testing": true,
    "better-few-shot": true,
    "add-user": true,
    "agent-autonomy-controls": false,
    "chat-agent-iq": true,
    "update-current-user-password": true,
    "chat-aible-agent-c": true, // SafeClaw
    "chat-aible-agent-reasoning-flow-step": true, // Turns on create claw from agent
    "chat-conversation-memory": true,
    "aible-claw-read-memory": true,
    "aible-claw-api-invocations": true,
    "chat-aible-optimize": true, // Turns on Aible Optimize Agent for SafeClaw users
    "hide-prediction-nvidia-demo": false, // Enables Prediction Tool in SafeClaw when false
    "aiq-deep-research-agent": true, // AI-Q Deep Research Agent access
    openshell: true, // OpenShell access
    "agent-simple-analytics": false // Add false override for safeClaw users
};
export const isEnabled = !!LAUNCH_DARKLY_SKD_KEY
    ? (flagName, defaultValue = false) => {
        // Dev Flag Toggle
        const DEBUG_FLAGS = {
            // "aible-business-simple": true,
            // "monitoring-demo": false,
            "aible-next": true,
            "aible-next-api": false,
            "hide-prediction-nvidia-demo": false
            //"aible-sense": false,
            // "aible-optimize": false,
            // "multi-document-dataset": false,
        };
        const isChatAible = client?.variation("chat-aible-consumer") ||
            window?.location?.href?.indexOf("www.chataible.com") !== -1 ||
            window?.location?.href?.indexOf("chataible.iamaible.com") !== -1;
        const forceChatAibleConsumer = isChatAible;
        // window?.location?.href?.indexOf("google.iamaible.com") !== -1;
        if (forceChatAibleConsumer) {
            DEBUG_FLAGS["chat-aible-consumer"] = true;
            DEBUG_FLAGS["chat-aible"] = true;
            DEBUG_FLAGS["sense-transformations"] = true;
            DEBUG_FLAGS["chat-aible-sql-queries"] = false;
            DEBUG_FLAGS["chat-aible-registration-redirect"] = true;
        }
        if (window?.location?.href?.indexOf("google.iamaible.com") !== -1) {
            DEBUG_FLAGS["google-slides-export"] = true;
            DEBUG_FLAGS["aible-explore"] = true;
            DEBUG_FLAGS["chat-aible"] = true;
            DEBUG_FLAGS["sense-transformations"] = true;
            // DEBUG_FLAGS["aible-optimize"] = false;
            DEBUG_FLAGS["chat-aible-buy-button"] = false;
            delete DEBUG_FLAGS["chat-aible-registration-redirect"];
            delete DEBUG_FLAGS["chat-aible-sql-queries"];
        }
        if (DEBUG_FLAGS && DEBUG_FLAGS[flagName] !== undefined) {
            return DEBUG_FLAGS[flagName];
        }
        return client?.variation(flagName, defaultValue) ?? false;
    }
    : (flagName, defaultValue = false) => {
        const userEmail = localStorage.getItem("aible_user_email");
        if (btoa(userEmail || "") === "YWRtaW5AYWlibGUuY29t" && ADMIN_FLAGS[flagName] !== undefined) {
            return ADMIN_FLAGS[flagName];
        }
        if (btoa(userEmail || "") === "c2FmZWNsYXdAYWlibGUuY29t" && SAFE_CLAW_FLAGS[flagName] !== undefined) {
            return SAFE_CLAW_FLAGS[flagName];
        }
        return DEFAULT_FLAGS[flagName] ?? false;
    };
